import { create } from "zustand";
import { api } from "@/services/api.service";
import { persist } from "zustand/middleware";

interface UserData {
  id: string;
  name: string;
  username: string;
  email?: string;
  profilePicture?: string;
  referralCode?: string;
  createdAt?: string;
  tier?: any;
  accountBalance?: number;
  nativeBalance?: number;
  tokens?: any;
  deposits?: number;
  withdraws?: number;
  role?: string;
  privileges?: number[];
  twoFactorEnabled?: boolean;
  bonusProgress: number;
  bonusReleaseThreshold: number;
}

export type UserState = {
  isAuthenticated: boolean;
  data: UserData;
  setIsAuthenticated: (value: boolean) => void;
  setData: (value: object) => void;
  fetchUserData: (callback?: (data: any) => void) => void;
  logout: () => void;
};

const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      data: {} as UserData,
      privileges: [],
      setIsAuthenticated: (value) => set(() => ({ isAuthenticated: value })),
      setData: (value) => set(() => ({ data: value as UserData })),
      logout: () => {
        set({
          isAuthenticated: false,
          data: undefined,
        });
      },
      fetchUserData: (callback?: (data: UserData) => void) => {
        api
          .get("/profile/account")
          .then((response) => {
            set({
              data: response?.data?.data,
            });
            if (callback && response) {
              const data = response?.data?.data;
              console.log("store data:", data);
              callback(data);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
    }),
    {
      name: "user-storage",
    },
  ),
);

export default useUserStore;
